import React, { Component } from 'react';

import language from '../../../assets/languages/language';
import { saveQuestion, getTokenAndEmail, getFavQuestion, deleteSaveQuestion  } from '../services';
export class SaveQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isContentSaved: false,
    };
    
  }

  setIconColor = async (func, isContentSaved) => {
    const { favItemId, onSaveItemChange } = this.props;
    const data = {
      ...getTokenAndEmail(),
      favItemId,
    };

    const response = await func(data);
    if (func === getFavQuestion) {
      const isSaved = response.success && response.data && response.data.id;
      this.setState({ isContentSaved: !!isSaved });
      onSaveItemChange(!isSaved);
      return;
    }

    if (response.success) {
      onSaveItemChange(!isContentSaved);
      if (!isContentSaved) {
        const { setChildRef } = this.props;
        if (setChildRef) {
          setChildRef.deleteFlash();
        }
      }
      this.setState({ isContentSaved });
    } else {
      onSaveItemChange(true);
    }
  };
  setIconOnUnSave = async func => {
    const { favItemId, onSaveItemChange } = this.props;
    const data = {
      ...getTokenAndEmail(),
      favItemId,
    };

    const response = await func(data);
    if (response.success) {
      onSaveItemChange(false);
      this.setState({ isContentSaved: true });
    } else {
      onSaveItemChange(true);
    }
  };

  componentDidMount() {
    if (this.props.favItemId) {
      this.setIconColor(getFavQuestion);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.favItemId !== this.props.favItemId && this.props.favItemId) {
      this.setState({ isContentSaved: false });
      this.setIconColor(getFavQuestion);
    }
  }

  render() {
    const { isContentSaved } = this.state;
    return (
      <span className='up tooltip-hover-questions' style={{ marginRight: '10px' }}>
        <div className='tootip_box'> {language.LC().SAVE_QUESTION} </div>
        {console.log('checking the save state', isContentSaved)}
        <i
          className={`${
            isContentSaved
              ? 'fa fa-bookmark mark-action-btn-bookmark'
              : 'fa fa-bookmark-o mark-action-btn-bookmark'
          }`}
          onClick={() =>
            isContentSaved
              ? this.setIconColor(deleteSaveQuestion, false)
              : this.setIconColor(saveQuestion, true)
          }
          style={{ color: isContentSaved ? 'rgb(54, 141, 84)' : '' }}
        />
      </span>
    );
  }
}

export default SaveQuestion;



// WEBPACK FOOTER //
// ./src/views/ESG/QuestionBank/SaveQuestion.jsx